module.exports = __webpack_public_path__ + "assets/img/JEM.d78714f1.jpg";